var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled, Tooltip as MUITooltip, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
const StyledTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(MUITooltip, Object.assign({}, props, { classes: { popper: className } })));
}, { shouldForwardProp: (prop) => prop !== "themeColor" })(({ theme, themeColor }) => ({
    "& .MuiTooltip-tooltip": Object.assign(Object.assign({}, theme.typography.mediumText), { backgroundColor: themeColor === "light"
            ? theme.palette.primaryWhite.main
            : theme.palette.primaryBlack.main, border: themeColor === "light"
            ? `1px solid ${theme.palette.grey02.main}`
            : "none", borderRadius: convertPxToRem(15), boxShadow: `0 ${convertPxToRem(11)} ${convertPxToRem(18)} ${convertPxToRem(-3)} rgba(0, 0, 0, 0.17)`, color: themeColor === "light"
            ? theme.palette.primaryBlackText.main
            : theme.palette.primaryWhiteText.main }),
}));
const StyledSingleRowTooltip = styled(StyledTooltip)({
    height: convertPxToRem(39),
    maxWidth: convertPxToRem(284),
    "& .MuiTooltip-tooltip": {
        padding: `${convertPxToRem(8)} ${convertPxToRem(12)} ${convertPxToRem(10)}`,
    },
});
const StyledMultiRowTooltip = styled(StyledTooltip, {
    shouldForwardProp: (prop) => prop !== "headerText",
})(({ theme, headerText }) => ({
    maxWidth: convertPxToRem(340),
    "& .MuiTooltip-tooltip": {
        padding: convertPxToRem(12),
        // multiRow title
        "> span": {
            // headerText
            "> p": Object.assign(Object.assign({}, theme.typography.mediumTextStrong), { display: headerText !== null ? "block" : "none", margin: 0, paddingBottom: convertPxToRem(4) }),
        },
    },
}));
const StyledDiv = styled("div")({
    "*:hover": {
        cursor: "help",
    },
});
const StyledSpan = styled("span")({
    cursor: "help",
});
export const Tooltip = ({ children, headerText, onClose, onOpen, open, placement = "bottom", themeColor = "dark", testId, title, variant = "singleRow", }) => {
    const shortenedSingleRowTitle = title.length > 40 ? title.substring(0, 40) : title;
    const multiRowTitle = (_jsxs("span", { children: [headerText && _jsx("p", { children: headerText }), title] }));
    return (_jsxs(_Fragment, { children: [variant === "singleRow" && (_jsx(StyledSingleRowTooltip, Object.assign({ "data-testid": testId, title: shortenedSingleRowTitle, themeColor: themeColor, placement: placement, onClose: onClose, onOpen: onOpen, open: open, enterDelay: 300, leaveDelay: 400, PopperProps: { keepMounted: true } }, { children: children.props.disabled ? (_jsx(StyledSpan, { children: children })) : (_jsx(StyledDiv, { children: children })) }))), variant === "multiRow" && (_jsx(StyledMultiRowTooltip, Object.assign({ "data-testid": testId, title: multiRowTitle, themeColor: themeColor, placement: placement, onClose: onClose, onOpen: onOpen, open: open, enterDelay: 300, leaveDelay: 400, PopperProps: { keepMounted: true } }, { children: children.props.disabled ? (_jsx(StyledSpan, { children: children })) : (_jsx(StyledDiv, { children: children })) })))] }));
};
